import {
  Component,
  Inject,
  Injector,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { TuiDialogService } from "@taiga-ui/core";
import { PolymorpheusComponent } from "@tinkoff/ng-polymorpheus";
import * as moment from "moment";
import { ApiService } from "src/app/core/services/shared/api.service";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import { EncryptDecreptService } from "src/app/core/services/shared/encrypt-decrept.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { environment } from "src/environments/environment";
import { CodehelpService } from "virtue-form";
import { ExtendloginaccountComponent } from "../../shared/dialog/extendloginaccount/extendloginaccount.component";
import { ProfilePopupComponent } from "../../shared/dialog/profile-popup/profile-popup.component";
import { PaySubscribeComponent } from "../../shared/dialog/pay-subscribe/pay-subscribe.component";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  public clock;
  //imageURL = 'https://s3.us-east-2.amazonaws.com/assets.virtueanalytics.com/mse/top-five-list.png';
  //imageURL = "./assets/images/marquette-university-logo.png";
  //  imageURL = "./assets/images/virtue-logo.png";
  imageURL = "";
  srcProfile: string = "";
  FullName: string = "";
  user = "";
  hide = true;
  currentpage = 1;

  hidePaysubscriberBtn: boolean = false;
  addCounselorParam: boolean = true;
  navbarcss = "";
  links: any = [];
  containerCss = "container-fluid";
  logowithtxt: boolean = false;
  switchdasboard: boolean = false;
  formlogin: FormGroup;
  logowithtxtHTML: string = "";
  topheaderbanner: boolean = false;
  isVirtueLogin: boolean = false;
  topheaderbannerHTMl: string = "";
  IsLoadData: boolean = false;
  isLoginModelShow: boolean = false;
  logoURL: string = environment.logoURL;
  erroeMsg: string = "";
  time: any = "";
  basepath = "";
  first: any;
  secondTime: any;
  isLoginByRequestUrl: boolean = false;
  logoutuser: boolean = true;
  currentTime: string = "";
  userType: string = "";
  ExpireTime = "";
  isLoginStudentAsCounselor: boolean = false;
  loginInfo: any;
  constructor(
    private apiService: ApiService,
    private router: Router,
    public globalvar: GlobalVarService,
    private checkUserLogin: CheckLoginSessionService,
    private codehelp: CodehelpService,
    private EncryptDecrpt: EncryptDecreptService,
    @Inject(TuiDialogService) private readonly dialogService: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    this.basepath = this.globalvar.basepath;

    if (
      this.globalvar?.top5SubscriptionDashboardRequestData != undefined ||
      this.globalvar?.top5SubscriptionDashboardRequestData == "undefined"
    ) {
      if (
        this.globalvar?.top5SubscriptionDashboardRequestData?.top5_request ==
        true
      ) {
        this.isLoginByRequestUrl = true;
      }
    }

    if (this.globalvar.isLoginAsCounselor != undefined) {
      if (this.globalvar.isLoginAsCounselor.isLoginAsCounselor == true) {
        this.isLoginStudentAsCounselor = true;
      }
    }
  }

  ngOnInit() {
    this.globalvar.pageChange.subscribe((stepper) => {
      this.currentpage = stepper.page;
    });

    let login = this.codehelp.getStoreValue("LoginUserFrom");
    this.loginInfo = JSON.parse(this.codehelp.getStoreValue("LoginInfo") || "");
    // console.log(loginInfo, "loginINfo");
    if (login == "UserLogin") {
      this.switchdasboard = true;
    }

    let getExpireTime = this.codehelp.getStoreValue("LoginSessionHoure");
    if (getExpireTime) {
      this.timecount(getExpireTime);
    }

    let profile = JSON.parse(this.codehelp.getUserProfile() || "{}");
    this.userType = profile?.type || "";
    this.srcProfile = profile?.avatar || "";
    this.FullName = profile.fullName || "";
    this.hidePaysubscriberBtn = profile?.subscribedUser || "";
    console.log(this.hidePaysubscriberBtn, "HidenPayButton");
    this.globalvar.organizationLoaded.subscribe((resp) => {
      if (resp) {
        let login = this.codehelp.getStoreValue("LoginUserFrom");

        if (login == "StudentLoginAsCounselor") {
          this.isLoginStudentAsCounselor = true;
        }
        this.basepath = this.globalvar.basepath;
        this.imageURL = this.globalvar.logoUrl;
      }
    });
  }

  onLogout(type: string) {
    //this.router.navigate(["home/login"]);
    this.checkUserLogin.onLogout(type);
  }

  getOrganizationById(id: string, encrpt: string) {
    this.apiService.getOrganizationById(id).then(
      (resp: any) => {
        let data = resp.serviceConfigs.find(
          (item) => item.serviceType == "TOP5_SUBSCRIPTION"
        );

        let redirectURL = "";

        if (data.serviceUrl) {
          let service = data.serviceUrl;
          let Url = service.split("/");

          if (
            window.location.hostname == "tech.virtueanalytics.com" ||
            window.location.hostname == "localhost"
          ) {
            if (this.isLoginStudentAsCounselor) {
              redirectURL =
                "https://tech.virtueanalytics.com/top5SubscriberTech/" +
                Url[Url.length - 1] +
                "/login/" +
                this.setTokenAccessEncrptForm();
            } else {
              redirectURL =
                "https://tech.virtueanalytics.com/top5SubscriberTech/" +
                Url[Url.length - 1] +
                "/login/" +
                encrpt;
            }
          } else {
            if (this.isLoginStudentAsCounselor) {
              redirectURL =
                "https://app.virtueanalytics.com/top5Subscriber/" +
                Url[Url.length - 1] +
                "/login/" +
                this.setTokenAccessEncrptForm();
            } else {
              redirectURL =
                "https://app.virtueanalytics.com/top5Subscriber/" +
                Url[Url.length - 1] +
                "/login/" +
                encrpt;
            }
          }
          //   window.location.href =hostname;

          window.open(redirectURL, "_blank");
        }
      },
      (error) => {
        if (error.status == "500" || error.status) {
        }
      }
    );
  }

  setTokenAccessEncrptForm() {
    let obj = {
      isConselorLogin: true,
      accessToken: this.globalvar.isLoginAsCounselor.counselorTokenAccess,
    };
    var encrypted = this.EncryptDecrpt.set("govirtue@123", JSON.stringify(obj));
    const encrypted_split = encrypted.split("/");
    const ect_string = encrypted_split.join("***");

    return ect_string;
  }

  clickLink() {
    if (this.checkUserLogin.clickActionToCheckLogout() == true) {
      let obj = this.codehelp.getLoggedUserDetail();
      let user = JSON.parse(obj);
      let loginInfo = {
        username: user?.username,
        password: user?.password,
      };
      var encrypted = this.EncryptDecrpt.set(
        "govirtue@123",
        JSON.stringify(loginInfo)
      );
      const encrypted_split = encrypted.split("/");
      const ect_string = encrypted_split.join("***");
      this.getOrganizationById(user.orgRef.id, ect_string);
    }
  }
  // getFirstLetters(str) {
  //   const firstLetters = str
  //     .split(" ")
  //     .map((word) => word[0])
  //     .join("");

  //   return firstLetters;
  // }

  getFirstLetters(str: string) {
    const firstLetters = str
      .split(" ")
      .map((word) => word[0])
      .join("");

    const twovalueofstring =
      firstLetters.charAt(0) + firstLetters.charAt(firstLetters.length - 1);
    return twovalueofstring.toUpperCase();
  }

  timecount(expireTime) {
    let hr = moment(expireTime).diff(moment().utc(), "hours");
    let x = setInterval(() => {
      let currentTime: any = moment().utc();
      // let ExpireTime: any = moment("2023-01-22 17:09:00");
      let ExpireTime: any = moment(expireTime);
      const totalminut = Math.ceil(Math.abs(ExpireTime - currentTime) / 1000);
      const hours = Math.floor(totalminut / 3600);
      const minute = totalminut % 3600;
      const minute2 = Math.floor(minute / 60);
      const second = minute % 60;
      // console.log("hours-", hours, " minute2-", minute2, " second", second);
      this.time = hours + "Hrs " + minute2 + "min ";
      // this.time = hours + "Hrs " + minute2 + "min and " + second + "sec ";
      if (hours == 0 && minute2 == 0 && second == 1) {
        // console.log(
        //   "Session Expire-",
        //   "hours-",
        //   hours,
        //   " minute2-",
        //   minute2,
        //   " second",
        //   second
        // );

        clearInterval(x);
        this.checkUserLogin.onLogout("Manual");
      }
    });
  }
  openProfileModelBox() {
    this.opendialog = this.dialogService.open<any>(
      new PolymorpheusComponent(ProfilePopupComponent, this.injector),
      {
        data: "",
        dismissible: false,
      }
    );
    this.opendialog.subscribe({
      next: (data: any) => {},
      complete: () => {},
    });
  }

  private opendialog = this.dialogService.open<any>(
    new PolymorpheusComponent(ProfilePopupComponent, this.injector),
    {
      data: "",
      dismissible: false,
      label: "Profile Info",
      size: "m",
    }
  );
  extendday() {
    let a = JSON.parse(this.codehelp.getLoggedUserDetail() || "");
    let chkpass = a?.password || "";
    let username = a?.username || "";
    let extenddayform = {
      username: username,
      password: chkpass,
      extendDay: "1",
    };

    this.apiService.extendday(extenddayform).then((res) => {
      {
        if (res) {
          this.dialog = this.dialogService.open<any>(
            new PolymorpheusComponent(
              ExtendloginaccountComponent,
              this.injector
            ),
            {
              data: {},
              dismissible: false,
            }
          );
          this.dialog.subscribe({
            next: (data) => {
              if (data == true) {
                //this.isExpireLogin = false;
              }
            },
            complete: () => {},
          });
        }
      }
    });
  }
  private dialog = this.dialogService.open<any>(
    new PolymorpheusComponent(ExtendloginaccountComponent, this.injector),
    {
      data: "",
      dismissible: false,
      size: "m",
    }
  );
  innerbutton() {
    this.dialogMailme = this.dialogService.open<any>(
      new PolymorpheusComponent(PaySubscribeComponent, this.injector),
      {
        data: "",
        dismissible: false,
        size: "s",
      }
    );
    this.dialogMailme.subscribe({
      next: (data) => {
        if (data != "") {
          // this.mailSubmit(data);
        }
      },
    });
  }
  private dialogMailme = this.dialogService.open<any>(
    new PolymorpheusComponent(PaySubscribeComponent, this.injector),
    {
      data: {},
      dismissible: false,
      closeable: false,
      label: "",
      size: "s",
    }
  );

  MyAccount() {
    this.globalvar.previousPageUrl = this.currentpage;

    //  this.globalvar.loadOrganization(false, false, true);
    // this.globalvar.change(1);
    // this.router.navigate(["/home/steps/1"]);
    // this.globalvar.redirectPage(pg, true, false, false);
    this.router.navigate(["home/Accounts"]);
  }
}
